export enum reportQuarter {
    Q1 = 1,
    Q2,
    Q3,
    Q4,
}